<h2 mat-dialog-title>{{ 'SESSION.EXPIRED_TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'SESSION.EXPIRED_TEXT' | translate }}</p>
  @if (failed) {
    <p class="mt-3 text-red-600">{{ 'SESSION.LOGIN_FAILED' | translate }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [disabled]="busy" (click)="dialogRef.close()">
    {{ 'SESSION.LATER' | translate }}
  </button>
  <button mat-flat-button color="accent" [disabled]="busy" (click)="login()">
    {{ 'SESSION.LOGIN_AGAIN' | translate }}
  </button>
</mat-dialog-actions>
